import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ImgPreviewComponent } from '../img-preview/img-preview.component';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'calsoft-product-image2',
  templateUrl: './product-image2.component.html',
  styleUrls: ['./product-image2.component.scss']
})
export class ProductImage2Component implements OnInit{

  @Input() image: any;
  @Input() zoomImage: any;
  @Input() productIdAddedInCart: any={};
  @Input()  data: any;
  @Input()  product: any;
  @Input()  productDetailHeightMobile: any;
  @Input()  productDetailWidthMobile: any;
  @Input()  productDetailHeight: any;
  @Input()  productDetailWidth: any;
  @Input()  name: any;

  public serverPath7 = environment.commonImageApi+"catalog/product";

  
  @ViewChild('zoomViewer', { static: true }) zoomViewer;
  @Input() highlighted: any;
  lightBoxOption = {
		showImageNumberLabel: true,
		centerVertically: true,
		showZoom: true,
		fadeDuration: .2,
		albumLabel: "%1 / %2"
	}
  img_album:any = [];
  imagepath:any;

  constructor(
    public dialog: MatDialog,
    private _lightbox: Lightbox
     ) { }

  ngOnInit(): void {
    this.highlighted=0;
    this.lightimage();
  }
  @Input()genuineProductText: any;
  @Input()deliveryTime: any;
  @Input()deliveryDoorStepText: any;
  @Input()ColdChain: any;
  @Input() displayColdChain: any;
  @Input() deliveryDoorStepIcon: any;
  @Input() showTimeIcon: any;
  @Input() showGenuineProductIcon: any;
  @Input() productzoom: any;
  @Input() configProductSelected: any;
  @Input()imageList: any=[];
  @Input() productDetailImageWidth: any=70;
  private bigImage = environment.ImageAPI1;
  commonImageApi=environment.commonImageApiNew;

  @Output() mouseMoveEvent = new EventEmitter<string>();

  @Output() leaveMoveEvent = new EventEmitter<string>();

  @Output() zoomImageEvent = new EventEmitter<string>();
  public onMouseMove(e) {

    this.mouseMoveEvent.emit(e);
    // if (window.innerWidth >= 1280) {
    //   var image, offsetX, offsetY, x, y, zoomer;
    //   image = e.currentTarget;
    //   offsetX = e.offsetX;
    //   offsetY = e.offsetY;
    //   x = offsetX / image.offsetWidth * 100;
    //   y = offsetY / image.offsetHeight * 100;
    //   zoomer = this.zoomViewer.nativeElement.children[0];
    //   if (zoomer) {
    //     zoomer.style.backgroundPosition = x + '% ' + y + '%';
    //     zoomer.style.display = "block";
    //     zoomer.style.height = image.height + 'px';
    //     zoomer.style.width = image.width + 'px';
    //   }
    // }
  }

  public onMouseLeave(event) {

   
    this.leaveMoveEvent.emit(event);
   // this.zoomViewer.nativeElement.children[0].style.display = "none";
  }

  imagePreview(images, index) {

    if (window.innerWidth > 1024) {
      const dialogRef = this.dialog.open(ImgPreviewComponent, {
        height:'700px',   width: '700px', data: { page: index, images: images }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
      });

    } else if (window.innerWidth == 1024) {
      const dialogRef = this.dialog.open(ImgPreviewComponent, {
       height:'600px', width: '600px',data: { page: index, images: images }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
      });

    }
    
    else{

      const dialogRef = this.dialog.open(ImgPreviewComponent, {
        minWidth: '100vw', height: '100vh', data: { page: index, images: images }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
      });

    }

  }

  public selectImage(image, i) {
    this.highlighted = i;
    this.image = this.bigImage + image;
    this.zoomImage = this.bigImage + image;
    this.zoomImageEvent.emit(this.zoomImage)
  }

  public selectImage2(image, i) {
    this.highlighted = i;
    this.image =  image;
    this.zoomImage =  image;
    this.zoomImageEvent.emit(this.zoomImage)
  }


  public selectImage1(image, i) {
    this.highlighted = i;
    this.image = this.commonImageApi + image;
    this.zoomImage = this.commonImageApi + image;

    this.zoomImageEvent.emit(this.zoomImage)
  }

  public selectImage3(image, i) {
    this.highlighted = i;
    this.image = this.serverPath7 + image;
    this.zoomImage = this.serverPath7 + image;

    this.zoomImageEvent.emit(this.zoomImage)
  }

  lightimage(){

    for (let i = 0; i < this.imageList.length; i++) {

      if(this.imageList[i].includes('http')){
        this.imagepath = '';
      }
      else if(this.imageList[i].includes('medicineimages')){
        this.imagepath = this.commonImageApi;
      }
      else if(this.imageList[i].includes('commonimages')){
        this.imagepath = this.serverPath7;
      }
      else if (!this.imageList[i].includes('medicineimages') && !this.imageList[i].includes('http') && !this.imageList[i].includes('commonimages')) {
        this.imagepath = this.bigImage;
      }
  
      const src = this.imagepath+this.imageList[i];
      //const caption = 'Image ' + (i + 1);
      const thumb = this.imagepath+this.imageList[i];
      const album = {
        src: src,
        //caption: caption,
        thumb: thumb
      };

      this.img_album.push(album);
    }
    
}

openlightBox(): void {
  // open lightbox
  this._lightbox.open(this.img_album, this.highlighted, this.lightBoxOption);
}

close(): void {
  // close lightbox programmatically
  this._lightbox.close();
}



}
